import React from "react";
import {IAttributeHeaderProps} from "../../../../utils/cellInterfaces";
import {Header} from "./header";

export function AttributeHeader(props: IAttributeHeaderProps) {
    return <Header displayName={props.attribute.displayName}
                   referenceName={props.attribute.referenceName}
                   description={props.attribute.description}
                   noTh={props.noTh}
    />
}



